(($, Drupal) => {
  // @todo split this into seperate files
  // Carousel initialisation
  $(".js-carousel").each(function () {
    $(this).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      appendArrows: $(this).closest(".carousel").find(".js-carousel-title"),
    });
  });
  // Carousel initialisation
  $(".js-carousel-challenges").each(function () {
    $(this).slick({
      centerMode: true,
      centerPadding: "12.5%",
      slidesToShow: 3,
      arrows: false,
      dots: true,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 820,
          settings: {
            centerPadding: "2.5%",
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
      ],
    });
  });

  // Square Carousel Title Only
  $(".js-carousel-square-title-only > .slideshow").each(function () {
    $(this).on("init", function () {
      const arrows = $(
        $(this).closest(".grid_wrapper").find(".js-arrow-container")
      );

      if (arrows.children().length > 0) {
        arrows.addClass("init");
      }
    });

    $(this).slick({
      centerMode: true,
      centerPadding: "12.5%",
      slidesToShow: 3,
      appendArrows: $(this)
        .closest(".grid_wrapper")
        .find(".js-arrow-container"),
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 820,
          settings: {
            centerPadding: "2.5%",
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
      ],
    });
  });

  // Carousel initialisation
  $(".js-carousel-wildlife").each(function () {
    $(this).slick({
      centerPadding: "12.5%",
      slidesToShow: 4,
      appendArrows: $(this)
        .closest(".carousel--circular")
        .find(".js-arrow-container"),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 820,
          settings: {
            centerPadding: "2.5%",
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            centerMode: true,
          },
        },
      ],
    });
  });

  // Carousel initialisation
  $(".js-thumbnail-carousel-wrap").each(function (n) {
    const $this = $(this);
    // $this.prepend("<p>test" + n + "</p>");
    $this.find(".js-thumbnail-carousel").slick({
      infinite: true,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: $this.find(".js-thumbnail-nav"),
      arrows: false,
    });

    $this.find(".js-thumbnail-nav").slick({
      slidesToShow: 5,
      asNavFor: $this.find(".js-thumbnail-carousel"),
      dots: false,
      arrows: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 820,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });
  });

  // Next slide click function
  $(".js-next-slide").on("click", function () {
    const wrap = $(this).closest(".js-thumbnail-carousel-wrap");
    $(wrap).find(".js-thumbnail-carousel").slick("slickNext");
    const sliderItemId = $(wrap)
      .find(".js-thumbnail-carousel .slick-current")
      .attr("data-slick-index");
    $(wrap).find(".js-thumbnail-nav .slick-slide").removeClass("slick-current");
    $(wrap)
      .find(
        `.js-thumbnail-nav .slick-slide[data-slick-index="${sliderItemId}"]`
      )
      .addClass("slick-current");
  });

  // Previous slide click function
  $(".js-previous-slide").on("click", function () {
    const wrap = $(this).closest(".js-thumbnail-carousel-wrap");
    $(wrap).find(".js-thumbnail-carousel").slick("slickPrev");
    const sliderItemId = $(wrap)
      .find(".js-thumbnail-carousel .slick-current")
      .attr("data-slick-index");
    $(wrap).find(".js-thumbnail-nav .slick-slide").removeClass("slick-current");
    $(wrap)
      .find(
        `.js-thumbnail-nav .slick-slide[data-slick-index="${sliderItemId}"]`
      )
      .addClass("slick-current");
  });
})(jQuery, Drupal);
